"use client";

import createIcon from './util/createIcon';
export default createIcon('M12,7.77L18.39,18H5.61L12,7.77M12,4L2,20H22', 'Delta');